import { call, put, takeLatest } from "redux-saga/effects";
import { ToastError } from "components/Global/Toasts/Toasty";
import { downloadXLSFile } from "utils/api";
import {
  defaultReturn
  , makePayload
  , generateDefaultActions
  , requestSaga
} from "shared-utility/store/utils/helpers";

// ACTIONS
export const LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA");
export const loanProceedsCalculatorResetTestData = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA.value, payload);
function* loanProceedsCalculatorResetTestDataSaga(payload) {
  yield put(LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA);
}

export const LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS");
export const getLoanProceedAssumptions = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.value, payload);
function* getLoanProceedAssumptionsSaga(payload) {
  const url = "/loan/getLoanProceedAssumptions";
  yield requestSaga(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS, url, "POST", payload);
}

export const LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID");
export const getLoanProceedAssumptionsByDealId = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, payload);
function* getLoanProceedAssumptionsByDealIdSaga(payload) {
  const url = "/loan/getLoanProceedAssumptionsByDealId";
  yield requestSaga(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID, url, "POST", payload);
}

export const LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS");
export const getDealPropertyProjections = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.value, payload);
function* getDealPropertyProjectionsSaga(payload) {
  const url = `/getDealPropertyProjections/${payload.dealId}`;
  yield requestSaga(LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS, url);
}

export const LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS");
export const calculateLoanProceeds = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS.value, payload);
function* calculateLoanProceedsSaga(payload) {
  const url = "/calc/calculateLoanProceeds";
  yield requestSaga(LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS, url, "POST", payload);
  if (payload.callback) {
    payload.callback();
  }
}

// NOTE: this was not referenced in the reducer!
export const LOAN_PROCEEDS_CALCULATOR_DOWNLOAD_LOAN_PROCEEDS = generateDefaultActions("LOAN_PROCEEDS_CALCULATOR_DOWNLOAD_LOAN_PROCEEDS");
export const downloadLoanProceeds = payload => makePayload(LOAN_PROCEEDS_CALCULATOR_DOWNLOAD_LOAN_PROCEEDS.value, payload);
function* downloadLoanProceedsSaga(payload) {
  try {
    yield call(downloadXLSFile, "downloadLoanProceeds", "POST", payload);
  } catch (error) {
    yield put(LOAN_PROCEEDS_CALCULATOR_DOWNLOAD_LOAN_PROCEEDS.createFailure(error));
  }
}

// REDUCER

const initialState = {
  loanProceedAssumptions: null,
  consolidatedProjections: null,
  loanProceeds: null
};

export function loanProceedsCalculatorReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA:
      return {
        ...state,
        ...initialState
      };

    case LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.success:
      return defaultReturn(state, payload.data, "loanProceedAssumptions");

    case LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.success:
      const loanProceedAssumptions = payload.data ? payload.data[0] : "Not Set";

      return defaultReturn(state, loanProceedAssumptions, "loanProceedAssumptionsForDeal");

    case LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.success:
      const consolidatedProjections = payload && payload.result && payload.result.consolidatedProjections ? payload.result.consolidatedProjections : {};

      return defaultReturn(state, consolidatedProjections, "dealPropertyProjections");

    case LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS.success:
      payload.success = true;

      return defaultReturn(state, payload, "loanProceeds");

    case LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS.failure:
      payload.success = false;
      ToastError(payload.response.data.message);

      return defaultReturn(state, payload, "loanProceeds");

    default:
      return state;
  }
}

// SAGA

export function* loanProceedsCalculatorSaga() {
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_GET_DEAL_PROPERTY_PROJECTIONS.value, getDealPropertyProjectionsSaga);
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_RESET_TEST_DATA.value, loanProceedsCalculatorResetTestDataSaga);
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS.value, getLoanProceedAssumptionsSaga);
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_GET_LOAN_PROCEED_ASSUMPTIONS_BY_DEALID.value, getLoanProceedAssumptionsByDealIdSaga);
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_CALCULATE_LOAN_PROCEEDS.value, calculateLoanProceedsSaga);
  yield takeLatest(LOAN_PROCEEDS_CALCULATOR_DOWNLOAD_LOAN_PROCEEDS.value, downloadLoanProceedsSaga);
}
